import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  private readonly phoneNumberPattern = /^\+(?:[0-9]\.?){6,14}[0-9]$/;

  transform(value: string): string {
    if (!value) {
      return '';
    }

    const formattedNumber = value.replace(this.phoneNumberPattern, (match) => {
      const countryCode = match.substring(1, 4);
      const remainingDigits = match.substring(4);

      const formattedNumber = `+(${countryCode}) ${remainingDigits}`;

      return formattedNumber;
    });

    return formattedNumber;
  }
}
